import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './equipment-allotment-charge.reducer';

export const EquipmentAllotmentChargeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const equipmentAllotmentChargeEntity = useAppSelector(state => state.equipmentAllotmentCharge.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="equipmentAllotmentChargeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.equipmentAllotmentCharge.detail.title">EquipmentAllotmentCharge</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.equipmentAllotmentCharge.id">Id</Translate>
            </span>
          </dt>
          <dd>{equipmentAllotmentChargeEntity.id}</dd>
          <dt>
            <span id="fromDate">
              <Translate contentKey="tinyMedicRestApp.equipmentAllotmentCharge.fromDate">From Date</Translate>
            </span>
          </dt>
          <dd>{equipmentAllotmentChargeEntity.fromDate}</dd>
          <dt>
            <span id="toDate">
              <Translate contentKey="tinyMedicRestApp.equipmentAllotmentCharge.toDate">To Date</Translate>
            </span>
          </dt>
          <dd>{equipmentAllotmentChargeEntity.toDate}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.equipmentAllotmentCharge.active">Active</Translate>
            </span>
          </dt>
          <dd>{equipmentAllotmentChargeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.equipmentAllotmentCharge.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{equipmentAllotmentChargeEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.equipmentAllotmentCharge.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{equipmentAllotmentChargeEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.equipmentAllotmentCharge.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{equipmentAllotmentChargeEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.equipmentAllotmentCharge.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{equipmentAllotmentChargeEntity.timestampEntry}</dd>
          <dt>
            <span id="quantity">
              <Translate contentKey="tinyMedicRestApp.equipmentAllotmentCharge.quantity">Quantity</Translate>
            </span>
          </dt>
          <dd>{equipmentAllotmentChargeEntity.quantity}</dd>
          <dt>
            <span id="discount">
              <Translate contentKey="tinyMedicRestApp.equipmentAllotmentCharge.discount">Discount</Translate>
            </span>
          </dt>
          <dd>{equipmentAllotmentChargeEntity.discount}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.equipmentAllotmentCharge.allotment">Allotment</Translate>
          </dt>
          <dd>{equipmentAllotmentChargeEntity.allotment ? equipmentAllotmentChargeEntity.allotment.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.equipmentAllotmentCharge.appliedCharge">Applied Charge</Translate>
          </dt>
          <dd>{equipmentAllotmentChargeEntity.appliedCharge ? equipmentAllotmentChargeEntity.appliedCharge.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.equipmentAllotmentCharge.multiplierEntry">Multiplier Entry</Translate>
          </dt>
          <dd>{equipmentAllotmentChargeEntity.multiplierEntry ? equipmentAllotmentChargeEntity.multiplierEntry.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/equipment-allotment-charge" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/equipment-allotment-charge/${equipmentAllotmentChargeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default EquipmentAllotmentChargeDetail;
